import gtag from './gtag';
import dataLayer from './dataLayer';

const TRACKING_TYPE = 'gtag'; // or 'dataLayer'

// Will log tracking output to the console
const DEBUG = false;

const types = {
  gtag,
  dataLayer,
};

export default {
  /**
   * @param {string} category
   * @param {string} action
   * @param {string} label
   * @param {number} value
   */
  event(...params) {
    this.debug(...params);
    types[TRACKING_TYPE].event(...params);
  },

  /**
   * @param {string} category
   * @param {number} value
   */
  timing(...params) {
    this.debug(...params);
    types[TRACKING_TYPE].timing(...params);
  },

  debug(...params) {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.log('Tracking', params);
    }
  },
};
